module.exports = __webpack_public_path__ + "static/logo@3x-251488d54712aa237df1d8c0c1210a9d.png";